import { render, staticRenderFns } from "./homePC.vue?vue&type=template&id=fb8f7e40"
import script from "./homePC.vue?vue&type=script&lang=js"
export * from "./homePC.vue?vue&type=script&lang=js"
import style0 from "./homePC.vue?vue&type=style&index=0&id=fb8f7e40&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports